import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

const WP_URL = 'https://blog.thecryptotutor.com/';

export default function HeroSection() {
  const [heroTitle, setHeroTitle] = useState<string>('Your Hero Title');
  const [heroImage, setHeroImage] = useState<string | null>(null);
  const [heroImage2, setHeroImage2] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  // Fetch Hero Section from WP
  useEffect(() => {
    const fetchHeroData = async () => {
      try {
        const pageRes = await fetch(`${WP_URL}/wp-json/wp/v2/pages?slug=home&_embed`);
        const pages = await pageRes.json();
        if (!pages || pages.length === 0) return;

        const homePage = pages[0];
        const acf = homePage.acf || {};

        setHeroTitle(acf.h1_title || 'Your Hero Title');

        if (acf.hero_section_image) {
          const mediaRes = await fetch(`${WP_URL}/wp-json/wp/v2/media/${acf.hero_section_image}`);
          const media = await mediaRes.json();
          setHeroImage(media.source_url || media.guid?.rendered || null);
        }

        if (acf.hero_section_image_2) {
          const mediaRes2 = await fetch(`${WP_URL}/wp-json/wp/v2/media/${acf.hero_section_image_2}`);
          const media2 = await mediaRes2.json();
          setHeroImage2(media2.source_url || media2.guid?.rendered || null);
        }

      } catch (err) {
        console.error('Error fetching hero section:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroData();
  }, []);

  return (
    <section className="relative bg-[#F5F7FA] py-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left z-10">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              {heroTitle.split(' ').map((word, i, arr) => (
                <span
                  key={i}
                  className={i === arr.length - 1 ? 'text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600' : ''}
                >
                  {word}{' '}
                </span>
              ))}
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-4 font-medium">
              Join our <strong>FREE daily newsletter 📧</strong>
            </p>

            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Stay ahead in Crypto with Market Insights, Exchange Updates & Expert Tips from Industry Leaders
            </p>

            {/* Mailchimp Embedded Form */}
            <form
              action="https://us1.list-manage.com/subscribe/post?u=e497c4d40a423ce7cd5d95221&id=1e184fb803"
              method="POST"
              target="_blank"
              noValidate
              className="flex flex-col sm:flex-row gap-3 max-w-md"
            >
              <input
                type="email"
                name="EMAIL"
                placeholder="Enter your email"
                required
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              />
              <Button
                type="submit"
                className="px-6 py-3 whitespace-nowrap"
              >
                Subscribe
              </Button>
            </form>
          </div>

          {/* Right Content */}
          <div className="flex justify-center lg:justify-end z-10">
            <div className="relative w-full max-w-md h-120 lg:h-[480px] overflow-hidden rounded-lg">
              {loading ? (
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-gray-400">Loading image...</span>
                </div>
              ) : heroImage ? (
                <img src={heroImage} alt="Hero" className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-blue-100 to-purple-100 flex items-center justify-center">
                  <span className="text-gray-400">No image found</span>
                </div>
              )}

              {heroImage2 && (
                <img
                  src={heroImage2}
                  alt="Hero 2"
                  className="absolute top-0 left-0 w-full h-full object-cover opacity-50"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
